import React, { useEffect } from 'react';
import Carousel from '../components_cci/Carousel';
import DownloadQR from '../components_cci/QRCodeLink';
import Map from '../components_cci/Map';
import BlockInfos from '../components_cci/BlockInfos.jsx';
import DescriptionComponent from '../components_cci/Description.jsx';

interface Organization {
    Directors: { Text: string };
    Slogan?: { Text: string };
    Video: { Url: string; Text?: string };
    Color?: { Text: string};
    Type?: { Text: string};
}

const OrganizationInfo = ({ organization, Name }: { organization: Organization, Name: string}) => {
    if (!organization) return null;

    const { Directors, Slogan } = organization;

    return (
        <div className="rf-relative rf-pb-4 rf-flex-col rf-items-start rf-justify-center">
            <div className="rf-w-full rf-flex rf-flex-row rf-justify-between ltr:rf-items-start rtl:rf-items-end">
                <div className="rf-uppercase rf-w-fit rf-py-2 large:rf-py-3 rf-px-4 rf-bg-black rf-text-primary" style={{ color: organization.Color?.Text }}>{organization.Type?.Text}</div>
            </div>
            <div className="rf-py-6 rf-title-large-bold-size-auto large-vertical:rf-pt-[16.67%] rf-flex rf-flex-row rf-items-center rf-font-bold">{Name}</div>
            {organization.Slogan && (
                <div
                    className="rf-py-1 rf-px-4 rf-subtitle-size-auto rf-bg-primary rf-text-truewhite"
                    style={{ backgroundColor: organization?.Color?.Text }}
                >
                    {organization.Slogan.Text}
                </div>
            )}
        </div>
    );
};

interface Detail_POI_props {
    props: {
        locale: string;
        isUsedOnBorne: boolean;
        baseAddress: string;
        sendPostBack: any;
        FireOrganization: Organization,
        WaterOrganization: Organization,
        OtherOrganization: Organization,
        WindOrganization: Organization,
        WoodOrganization: Organization,
        DirtOrganization: Organization,
        Place: {
            AddressLocality: { Text: string };
            Latitude: { Value: number };
            Logo: { Paths: string };
            Longitude: { Value: number };
            PostalCode: { Text: string };
            StreetAddress: { Text: string };
            Telephone: { Text: string };
        },
        Thing: {
            Name: { Text: string };
            AdditionalType?: { Text: string | null };
            AlternateName?: { Text: string | null };
            Description?: { Text: string | null };
            DisambiguatingDescription?: { Text: string | null };
            Identifier?: { Text: string | null };
            Image?: {
                Paths: string[];
                MediaTexts: string[];
            };
            MainEntityOfPage?: { Text: string | null };
            PotentialAction?: { Text: string | null };
            SameAs?: { Text: string | null };
            SubjectOf?: { Text: string | null };
            Url?: {
                Url: string;
                Text: string | null;
                Target: string | null;
            };
            Favorite?: { Value: boolean };
            Categories?: { Values: string[] };
            AcceptedPaymentMethod?: { Text: string | null };
        }
    }
}

interface MediaPath {
    type: "image" | "video";
    src: string;
}

const Detail_POI = ({
    props: {
        locale,
        isUsedOnBorne,
        baseAddress,
        sendPostBack,
        FireOrganization,
        WaterOrganization,
        OtherOrganization,
        WindOrganization,
        WoodOrganization,
        DirtOrganization,
        Place: {
            AddressLocality,
            Latitude,
            Logo,
            Longitude,
            PostalCode,
            StreetAddress,
            Telephone
        },
        Thing: {
            Name,
            AdditionalType,
            AlternateName,
            Description,
            Identifier,
            Image,
            MainEntityOfPage,
            PotentialAction,
            SameAs,
            SubjectOf,
            Url,
            Favorite,
            Categories,
            AcceptedPaymentMethod
        }
    }
}: Detail_POI_props) => {

    useEffect(() => {
        console.log(locale, isUsedOnBorne, baseAddress, sendPostBack, FireOrganization, WaterOrganization, OtherOrganization, WindOrganization, WoodOrganization, DirtOrganization, AddressLocality, Latitude, Logo, Longitude, PostalCode, StreetAddress, Telephone, Name, AdditionalType, AlternateName, Description, Identifier, Image, MainEntityOfPage, PotentialAction, SameAs, SubjectOf, Url, Favorite, Categories, AcceptedPaymentMethod);
    }, [locale, isUsedOnBorne, baseAddress, sendPostBack, FireOrganization, WaterOrganization, OtherOrganization, WindOrganization, WoodOrganization, DirtOrganization, AddressLocality, Latitude, Logo, Longitude, PostalCode, StreetAddress, Telephone, Name, AdditionalType, AlternateName, Description, Identifier, Image, MainEntityOfPage, PotentialAction, SameAs, SubjectOf, Url, Favorite, Categories, AcceptedPaymentMethod]);

    const carouselItems: MediaPath[] = [];
    if (Image?.Paths) {
        Image.Paths.forEach((path) => {
            carouselItems.push({ type: 'image', src: path });
        });
    }

    const organizationList : Organization[] = [
        FireOrganization,
        WaterOrganization,
        OtherOrganization,
        WindOrganization,
        WoodOrganization,
        DirtOrganization
    ];

    let organizationFind: Organization | null = null;

    // Liste des noms en fonction de l'index
    const typeNames = [
        "Feu",
        "Eau",
        "Autre Réussite",
        "Air",
        "Bois",
        "Terre"
    ];

    const colorThemes  = [
        "rgb(252, 149, 46)",        //Feu
        "rgba(50, 222, 199, 1)",    //Eau
        "rgba(228, 138, 219, 1)",   //Autre
        "rgba(111, 207, 255, 1)",   //Air
        "rgba(143, 92, 41, 1)",     //Bois
        "rgba(110, 206, 97, 1)"     //Terre
    ]

    for (let i = 0; i < organizationList.length; i++) {
        const organization = organizationList[i];
        if (organization != null) {
            organization.Type ??= { Text: "" };
            organization.Color ??= { Text: "" };
            organization.Type.Text = typeNames[i];
            organization.Color.Text = colorThemes[i];
            organizationFind = organization;
            break;
        }
    }

    if (organizationFind?.Video?.Url) {
            carouselItems.push({ type: 'video', src: organizationFind.Video.Url });
    }

    return (
        <div className="rf-relative rf-flex rf-flex-row vertical:rf-flex-col rf-h-full rf-overflow-y-scroll rf-scrollbar-hidden">
            <div className="rf-px-6 large:rf-px-8 rf-w-2/3 vertical:rf-w-full rf-mb-4 large:rf-mb-0 rf-flex rf-flex-col rf-border-r rf-border-r-silver vertical:rf-border-r-0">
                {organizationFind && (
                    <OrganizationInfo organization={organizationFind} Name={Name.Text} />
                )}

                <div className="rf-flex rf-flex-col large:rf-flex-row landscape-retorik:rf-h-full">
                    
                    <DescriptionComponent text={Description?.Text}/>

                    {carouselItems.length > 0 && (
                        <Carousel items={carouselItems}/>
                    )}

                    {/* <div className="large:rf-min-w-1/2 large:rf-pl-4 rf-flex rf-flex-col rf-items-center">
                        <div className="rf-relative rf-flex rf-justify-center rf-align-center rf-w-full rf-aspect-[4/3] rf-mb-4 rf-overflow-hidden">
                            
                            
                        </div>
                    </div> */}
                </div>

                    {/* {Description?.Text && (
                        <div className="large-vertical:rf-max-h-[30vh] rf-font-medium rf-pb-4 rf-scroll-pb-4" style={{ maxHeight: '354px' }}>
                            {Description.Text}
                        </div>
                    )} */}

                <div className="rf-mt-4" style={{ color: organizationFind?.Color?.Text }}>Dirigeant(s)</div>
                <div>{organizationFind?.Directors.Text}</div>

                {Url?.Url && (
                    <div className="rf-w-full rf-flex">
                        <DownloadQR url={Url.Url} />
                    </div>
                )}
            </div>

            <div className="rf-relative rf-w-1/3 vertical:rf-w-full large:rf-bg-truewhite rf-flex rf-flex-col large-vertical:rf-flex-row items-center justify-center">
                
                <BlockInfos
                    Logo={Logo}
                    AddressLocality={AddressLocality}
                    StreetAddress={StreetAddress}
                    PostalCode={PostalCode}
                    Telephone={Telephone}
                />

                <div className="rf-relative large-vertical:rf-w-1/2" style={{ height: 'calc(-3rem + 50vw)' }}>
                    <Map latitude={Latitude.Value} longitude={Longitude.Value} />
                </div>
            </div>
        </div>
    );
};

export default Detail_POI;
